import { EmptyStateWhatsApp } from 'ui/illustrations';
import { displayContent } from '../../common/content';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { Message } from './Message';
import {
  containerStyles,
  deviceStylesCommon,
  deviceStylesUnset,
  messageContent,
  messageUnset,
} from './styles';

export const Preview = () => {
  const { hasContent } = useEditableFieldsContext();
  const shouldHidePreview = !hasContent;

  return (
    <div style={containerStyles}>
      <div
        data-test="template-editor-whats-app-preview"
        style={{
          ...deviceStylesCommon,
          ...(!shouldHidePreview ? messageContent : deviceStylesUnset),
        }}
      >
        {!shouldHidePreview ? (
          <Message />
        ) : (
          <>
            <EmptyStateWhatsApp data-test="empty-state-whats-app" />
            <div style={messageUnset}>{displayContent.strEmptyContentWhatsApp}</div>
          </>
        )}
      </div>
    </div>
  );
};

export default Preview;
